import React, {useState, createContext, useContext} from 'react';
import Callback from '../../Services/Callback';
import Icon from '../Icons/Icon';

const HelpContext = createContext();
const liveChatCallback = new Callback();

export const useHelpContext = () => {
    return useContext(HelpContext);
};

export default ({children}) => {

    const [openDoc, setOpenDoc] = useState(null);
    const [unreadMessages, setUnreadMessages] = useState(0);

    const docTrigger = (doc) => {
        return <span className="inline-block cursor-pointer fill-muted mx-3" onClick={() => setOpenDoc(doc)}>
            <Icon icon="CircleInfo" size="1x" />
        </span>
    }

    const providerValues = {
        showHelp: setOpenDoc,
        setOpenDoc,
        openDoc,
        unreadMessages,
        setUnreadMessages,
        setLiveChatCallback: (cb) => liveChatCallback.listen(cb),
        openLiveChat: () => liveChatCallback.invoke(),
        docTrigger,
    };

    return <HelpContext.Provider value={providerValues}>
        {children}
    </HelpContext.Provider>
}